module.exports = __webpack_public_path__ + "img/expovina-primavera_06(1).19f07ce0.jpg";